import React from 'react';

import Modal from './Modal';
import CondensedOrgPanel from './CondensedOrgPanel';

/*
Call this with
    <CondensedOrgModal
        show={the condition under which it should show}
        closeModalFunc={a function for closing the dialog}
        firmId={id of firm to show}
    />
*/

class CondensedOrgModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: undefined,
    };
  }

  render() {
    if (this.state.errorMessage) {
      return <h3>{this.state.errorMessage}</h3>;
    }

    const { show, firmId } = this.props;
    return (
      <Modal open={show} hideButtons={true} onCancel={this.props.closeModalFunc}>
        <CondensedOrgPanel visibleFirmId={firmId} closeModalFunc={this.props.closeModalFunc} />
      </Modal>
    );
  }
}

export default CondensedOrgModal;
